














import BaseComponent from '@/components/base-component.vue';
import { getBackEndVersion, getFrontVersion } from '@/services/version';
import moment from 'moment';
import Component from 'vue-class-component';

@Component
export default class Footer extends BaseComponent {
  public backEndVersion = { app: { version: null } };
  public frontEndVersion: string = '';
  public currentYear = moment().format('YYYY');

  public beforeMount(): void {
    this.initialize();
  }

  private async initialize(): Promise<void> {
    const data = await getBackEndVersion();
    this.backEndVersion = data;
    this.frontEndVersion = getFrontVersion();
  }
}
